import { htmlEscape } from "./StringUtils";

function getCleanTelephone(dirtytelephone: string): string {
    let telnr = "";
    if (dirtytelephone.length > 0) {
        telnr = dirtytelephone.replace(/^\+/, '00'); // indien eerste karakter een '+' dan deze vervangen door '00'
        telnr = telnr.replace(/\(0\)/g, '');         // indien ergens een '(0)' staat, deze verwijderen 
        telnr = telnr.replace(/[^0-9]/g, '');        // tenslotte alle overige niet-cijfers verwijderen
    }
    return telnr;
}

export function getTelephoneHyperlinks(dirtyinput: string): string {
    const splitter = '|';
    let encodedInput = htmlEscape(dirtyinput);
    let str_array = encodedInput.split(splitter);
    let returnarray: string[] = [];
    let count = str_array.length;
    for (let index = 0; index < count; index++) {
        let dirtyTelephone = str_array[index];
        let dirtyTrimmed = dirtyTelephone.trim();
        let cleanTelephone = getCleanTelephone(dirtyTrimmed);
        let resultTelephone = '';
        if (cleanTelephone.length > 0) {
            if (index > 0) {
                resultTelephone += ' ';
            }
            resultTelephone += '<a href="tel:' + cleanTelephone + '">' + dirtyTrimmed + '</a>';
            if (index < count - 1) {
                resultTelephone += ' ';
            }
        } else {
            resultTelephone = dirtyTelephone;
        }
        returnarray.push(resultTelephone);
    }
    return returnarray.join(splitter);
}

export function getAddressHyperlink(address: string, adresPcPlaats: string): string {
    if (address) {
        if (!adresPcPlaats) {
            adresPcPlaats = address;
        }

        let url: string;
        adresPcPlaats = encodeURIComponent(adresPcPlaats);
        let target = " target='_blank'";
        let userAgent = navigator.userAgent;

        if (userAgent.indexOf("iPhone") !== -1 || userAgent.indexOf("iPad") !== -1) {
            url = "maps://?q=" + adresPcPlaats;
        }
        else if (userAgent.indexOf("Android") !== -1) {
            url = "geo://?q=" + adresPcPlaats;
            target = "";
        }
        else {
            url = "http://maps.apple.com/?q=" + adresPcPlaats;
        }

        return "<a href='" + url.replace(/%20/g, "+") + "'" + target + ">" + htmlEscape(address) + "</a>";
    }
    else {
        return "";
    }
}

function createMailToLinkElement(emailAddress: string): string {
    return `<a href='mailto:${emailAddress}'>${emailAddress}</a>`;
}

export function getFieldAsEmailHyperlinks(emailAddresses: string) {
    if (emailAddresses === null || emailAddresses === "") {
        return "";
    }
    emailAddresses = emailAddresses.replace(/;/g, ',');
    let splitEmailAddresses: Array<string> = emailAddresses.split(',');

    let emailAddressLinkElements: string = "";

    for (let i = 0; i < splitEmailAddresses.length; i++) {
        let emailAddress: string = splitEmailAddresses[i];
        emailAddressLinkElements += createMailToLinkElement(emailAddress.trim());
        emailAddressLinkElements += splitEmailAddresses.length - 1 > i ? ", " : "";
    }
    return emailAddressLinkElements;
}

export function getExternalDocumentHyperlink(label: string, databindClick: string): string {
    let encodedLabel = htmlEscape(label);
    if (databindClick) {
        return '<a href="#" data-bind="click: ' + databindClick + '">' + encodedLabel + '</a>';
    }
    else {
        return encodedLabel;
    }
}

export function getFieldAsUrlAnchorElement(originalUrl: string): string {
    if (originalUrl === null || originalUrl === "") {
        return "";
    }

    let hrefUrl: string = originalUrl;
    if (!DoesUrlContainHttpOrHttps(originalUrl)) {
        hrefUrl = AddHttpPrefix(originalUrl);
    }

    return `<a href='${hrefUrl}' target='_blank'>${originalUrl}</a>`;
}

function AddHttpPrefix(url: string): string {
    return "http://" + url;
}

function DoesUrlContainHttpOrHttps(url: string): boolean {
    let regex: RegExp = /^(https?:\/\/)/;
    return url.match(regex) != null;
}